import api, { objectKeysToSnakeCase } from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';

import { MEDIA_PLAN_VERSIONS } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import {
  VersionListResponseSchema,
  type VersionListRequestPayload,
} from '../types/buyingPlanVersions.js';
import { useSelectedBuyingPlanId } from './useSelectedBuyingPlanId.js';

export const getVersionList = async (params: VersionListRequestPayload) => {
  const response = await api.get(MEDIA_PLAN_VERSIONS, {
    params: objectKeysToSnakeCase(params),
  });
  return VersionListResponseSchema.parse(response.data);
};

type VersionListArgs = Pick<
  VersionListRequestPayload,
  'page' | 'pageSize' | 'versionName'
>;
const KEEP_STALE_FOR_MS = 60 * 1000;

export const useGetVersionListData = (params?: VersionListArgs) => {
  const selectedPlanId = useSelectedBuyingPlanId();
  const payload = {
    mediaPlanId: selectedPlanId ?? 0,
    ...params,
  };

  return useQuery({
    queryKey: [QueryKey.GET_VERSION_LIST, payload],
    queryFn: () => getVersionList(payload),
    enabled: !!selectedPlanId,
    staleTime: KEEP_STALE_FOR_MS,
  });
};
